<template>
    <div v-if="isVisible" id="hhcookieconsent" :style="`background-color:${boxBackground}`">
        <div class="content" :style="`color:${textColor}`">
            {{text}}
        </div>
        <div id="hhcookieconsent_buttoncol">
            <button id="hhcookieconsent_okbutton" class="btn" :style="`background-color:${buttonBackgroundColor};color:${buttonTextColor}`" @click="hide()">OK</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CookieNotificator',
        data() {
            return {
                isVisible: false,
            };
        },
        methods: {
            hide() {
                localStorage.setItem('cookieconsent_given', '1');
                this.isVisible = false;
            },
        },
        created() {
            if (localStorage.getItem('cookieconsent_given') != '1') {
                this.isVisible = true;
            }
        },
        props: {
            text: {
                type: String,
                required: true,
            },
            boxBackground: {
                type: String,
                default: '#fff',
            },
            textColor: {
                type: String,
                default: '#000',
            },
            buttonBackgroundColor: {
                type: String,
                default: '#aaa',
            },
            buttonTextColor: {
                type: String,
                default: '#333',
            },
        },
    }
</script>

<style lang="scss">
    #hhcookieconsent {
        position: fixed;
        z-index: 999;
        left: 0;
        bottom: 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .content {
            padding: 7px 0 7px 10px;
            font-size: small;
            text-align: center;
        }
        #hhcookieconsent_okbutton {
            cursor: pointer;
            border: 0;
            border-radius: 5px;
            font-size: 18px;
            height: 40px;
            margin: 10px;
            padding: 0 1rem;
        }
    }
</style>
